import { bitcashRoom } from 'app-view/hooks/use-realtime'
import { IPair } from './pairs.schema'

export const useRealTimePairs = () => {
  const _pairs = bitcashRoom.useColyseusState((state) => state.pairs)
  const pairs = _pairs ? (_pairs.toJSON() as IPair) : {}
  return pairs
}
